import type { OperationSystem } from '@/global/types'

import { useEffect, useState } from 'react'

/**
 * Detect user's operation system
 *
 * @returns {OperationSystem}
 */
export function useTargetOS(): OperationSystem {
  const [userAgent, setUserAgent] = useState<string>()
  const [isTouchDevice, setIsTouchDevice] = useState<boolean>(false)

  const getUserAgent = (): string | undefined => {
    if (typeof window !== 'undefined') {
      return window.navigator.userAgent
    }

    return undefined
  }

  const getIfDeviceIsTouch = (): boolean => {
    if (typeof window !== 'undefined') {
      return window.navigator.maxTouchPoints > 1
    }

    return false
  }

  useEffect(() => {
    setUserAgent(getUserAgent())
    setIsTouchDevice(getIfDeviceIsTouch())
  }, [])

  if (!userAgent) {
    return 'unknown'
  }

  if (/iPhone/.test(userAgent)) {
    return 'iOS'
  }
  if (/macOS|Mac OS|OSX| Mac OS X|Macintosh/.test(userAgent) && isTouchDevice) {
    return 'iPadOS'
  }
  if (/macOS|Mac OS|OSX| Mac OS X|Macintosh/.test(userAgent)) {
    return 'macOS'
  }
  if (/android/i.test(userAgent)) {
    return 'Android'
  }
  if (/CrOS/.test(userAgent)) {
    return 'ChromeOS'
  }
  if (/Linux/.test(userAgent)) {
    return 'Linux'
  }
  if (/Windows|Win64|Windows NT| Win/.test(userAgent)) {
    return 'Windows'
  }

  return 'unknown'
}
